import { render, staticRenderFns } from "./AddChatBanKeywordsDialog.vue?vue&type=template&id=958c783c"
import script from "./AddChatBanKeywordsDialog.vue?vue&type=script&lang=js"
export * from "./AddChatBanKeywordsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports